/**
 * The unique identity symbol for the toast service.
 */
export const ToastServiceIdentity = Symbol("ToastService");
//# sourceMappingURL=toastService.js.map